const Tactic = require('../../entities/Tactic');
const { Age }  = require("../Constants");
const TacticNames = require("../Names/TacticNames");

class ModernArmy extends Tactic {
    constructor() {
        super(
            Age.Age3,
            TacticNames.ModernArmy,
            [2, 1, 1],
            "13(7)",
            {}
        )
    }
}

module.exports = ModernArmy;